"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleHeaderModule = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var GSWrapperComponent_1 = require("../../../../GSWrapperComponent");
var ArticleHeader_1 = require("./ArticleHeader");
function ArticleHeaderModule(props) {
    return (React.createElement(GSWrapperComponent_1.GSWrapperComponent, null,
        React.createElement(ArticleHeader_1.ArticleHeader, tslib_1.__assign({}, props))));
}
exports.ArticleHeaderModule = ArticleHeaderModule;
